import styled from "@emotion/styled"
import { Location } from "history"
import { FC, Suspense, useEffect, useState } from "react"
import { Router as BaseRouter } from "react-router"
import { Route, Switch } from "react-router-dom"
import lazy from "helpers/lazy"

import defaultBackground from "../../assets/background.png"
import backgroundDog from "../../assets/background-dog.jpg"

import { history } from "../../HistoryUtill"

const SubscriptionsPage = lazy(() =>
  import(
    /* webpackChunkName: "home" */ "./Subscriptions/SubscriptionsPage"
  ).then(x => ({
    default: x.SubscriptionsPage
  }))
)

const Amount = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Amount").then(x => ({
    default: x.Amount
  }))
)
const DefermentAttempt = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Defement/DefermentAttempt").then(
    x => ({
      default: x.DefermentAttempt
    })
  )
)
const DefermentFailed = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Defement/DefermentFailed").then(
    x => ({
      default: x.DefermentFailed
    })
  )
)
const DefermentInfo = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Defement/DefermentInfo").then(x => ({
    default: x.DefermentInfo
  }))
)
const DefermentSuccess = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Defement/DefermentSuccess").then(
    x => ({
      default: x.DefermentSuccess
    })
  )
)
const Detailing = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Detailing").then(x => ({
    default: x.Detailing
  }))
)
const FPSPay = lazy(() =>
  import(/* webpackChunkName: "home" */ "./FPSPay").then(x => ({
    default: x.FPSPay
  }))
)
const FPSPaySuccessfulDialog = lazy(() =>
  import(/* webpackChunkName: "home" */ "./FPSPaySuccessfulDialog").then(x => ({
    default: x.FPSPaySuccessfulDialog
  }))
)
const FSPPayExpiredDialog = lazy(() =>
  import(/* webpackChunkName: "home" */ "./FSPPayExpiredDialog").then(x => ({
    default: x.FSPPayExpiredDialog
  }))
)
const History = lazy(() =>
  import(/* webpackChunkName: "home" */ "./History").then(x => ({
    default: x.History
  }))
)
const Home = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Home").then(x => ({
    default: x.Home
  }))
)
const LinkCardDialog = lazy(() =>
  import(/* webpackChunkName: "home" */ "./LinkCardDialog").then(x => ({
    default: x.LinkCardDialog
  }))
)
const ManageCards = lazy(() =>
  import(/* webpackChunkName: "home" */ "./ManageCards").then(x => ({
    default: x.ManageCards
  }))
)
const PaymentAttempt = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Payment/PaymentAttempt").then(x => ({
    default: x.PaymentAttempt
  }))
)
const PaymentCheck = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Payment/PaymentCheck").then(x => ({
    default: x.PaymentCheck
  }))
)
const PaymentFailed = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Payment/PaymentFailed").then(x => ({
    default: x.PaymentFailed
  }))
)
const PaymentSuccess = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Payment/PaymentSuccess").then(x => ({
    default: x.PaymentSuccess
  }))
)
const PaymentConfirmation = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Payment/PaymentConfirmation").then(
    x => ({
      default: x.PaymentConfirmation
    })
  )
)
const Sales = lazy(() =>
  import(/* webpackChunkName: "home" */ "./Sales").then(x => ({
    default: x.Sales
  }))
)
const SelectCard = lazy(() =>
  import(/* webpackChunkName: "home" */ "./SelectCard").then(x => ({
    default: x.SelectCard
  }))
)

const Confermed = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Confermed").then(x => ({
    default: x.Confermed
  }))
)
const Confirmation = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Confirmation").then(x => ({
    default: x.Confirmation
  }))
)
const ConsoleBlocked = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/ConsoleBlocked").then(x => ({
    default: x.ConsoleBlocked
  }))
)
const Demo = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Demo").then(x => ({
    default: x.Demo
  }))
)
const Entry = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Entry").then(x => ({
    default: x.Entry
  }))
)
const Expired = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Expired").then(x => ({
    default: x.Expired
  }))
)
const ExpiredNotify = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/ExpiredNotify").then(x => ({
    default: x.ExpiredNotify
  }))
)
const InternetBlocked = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/InternetBlocked").then(x => ({
    default: x.InternetBlocked
  }))
)
const ServiceOffer = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Offer/ServiceOffer").then(
    x => ({ default: x.ServiceOffer })
  )
)
const TestingOffer = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Offer/TestingOffer").then(
    x => ({ default: x.TestingOffer })
  )
)
const ReplaceChoose = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/ReplaceChoose").then(x => ({
    default: x.ReplaceChoose
  }))
)
const ReplaceConsole = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/ReplaceConsole").then(x => ({
    default: x.ReplaceConsole
  }))
)
const Return = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/Return").then(x => ({
    default: x.Return
  }))
)
const UnblockConfirmation = lazy(() =>
  import(/* webpackChunkName: "trial" */ "./Trial/UnblockConfirmation").then(
    x => ({
      default: x.UnblockConfirmation
    })
  )
)

const CellsEmpty = lazy(() =>
  import(/* webpackChunkName: "cells" */ "./Widget/CellsEmpty").then(x => ({
    default: x.CellsEmpty
  }))
)
const CreateTicket = lazy(() =>
  import(/* webpackChunkName: "widget" */ "./Widget/CreateTicket").then(x => ({
    default: x.CreateTicket
  }))
)
const TicketSuccessful = lazy(() =>
  import(/* webpackChunkName: "widget" */ "./Widget/TicketSuccessful").then(
    x => ({
      default: x.TicketSuccessful
    })
  )
)
const Cells = lazy(() =>
  import(/* webpackChunkName: "cells" */ "./Widget/Cells").then(x => ({
    default: x.Cells
  }))
)
const Subscription = lazy(() =>
  import(/* webpackChunkName: "widget" */ "./Widget/Subscription").then(x => ({
    default: x.Subscription
  }))
)
const SubscriptionActivated = lazy(() =>
  import(
    /* webpackChunkName: "widget" */ "./Widget/SubscriptionActivated"
  ).then(x => ({
    default: x.SubscriptionActivated
  }))
)
const UnknownError = lazy(() =>
  import(/* webpackChunkName: "widget" */ "./Widget/UnknownError").then(x => ({
    default: x.UnknownError
  }))
)

const defaultBackgroundUrl = `url(${defaultBackground})`
const dogBackgroundUrl = `url(${backgroundDog})`
const widgetBackground = "rgba(0,0,0,0.3)"

export const Router: FC = () => {
  const [background, setBackground] = useState(
    /widget/.test(history.location.pathname)
      ? widgetBackground
      : defaultBackgroundUrl
  )

  useEffect(() => {
    const setter = (location: Location<unknown>) => {
      if (/widget/.test(location.pathname)) {
        setBackground(widgetBackground)
      } else if (/trial\/return/.test(location.pathname)) {
        setBackground(dogBackgroundUrl)
      } else if (background !== defaultBackgroundUrl) {
        setBackground(defaultBackgroundUrl)
      }
    }

    setter(history.location)
    return history.listen(setter)
  })

  return (
    <BaseRouter history={history}>
      <Container background={background}>
        <Suspense fallback={<div />}>
          <Switch>
            <Route path="/trial/offer/testing" component={TestingOffer} />
            <Route path="/trial/offer/service" component={ServiceOffer} />
            <Route path="/trial/confirmation" component={Confirmation} />
            <Route path="/trial/confermed" component={Confermed} />
            <Route path="/trial/demo" component={Demo} />
            <Route path="/trial/return" component={Return} />
            <Route path="/trial/expired-notify" component={ExpiredNotify} />
            <Route path="/trial/expired" component={Expired} />
            <Route
              path="/trial/unblock-confirmation"
              component={UnblockConfirmation}
            />
            <Route path="/trial/replace" component={ReplaceConsole} />
            <Route path="/trial/replace-choose" component={ReplaceChoose} />
            <Route path="/trial/internet-blocked" component={InternetBlocked} />
            <Route path="/trial/console-blocked" component={ConsoleBlocked} />
            <Route path="/trial" component={Entry} />

            <Route path="/widget/cells" component={Cells} />
            <Route path="/widget/cells-empty" component={CellsEmpty} />
            <Route
              path="/widget/ticket/successful"
              component={TicketSuccessful}
            />
            <Route path="/widget/ticket" component={CreateTicket} />
            <Route path="/widget/subscription" component={Subscription} />
            <Route
              path="/widget/subscription-activated"
              component={SubscriptionActivated}
            />
            <Route path="/widget/unknown-error" component={UnknownError} />
            <Route path="/widget" />

            <Route path="/detailing" component={Detailing} />
            <Route path="/fps-payment" component={FPSPay} />
            <Route path="/payment-card-selection" component={SelectCard} />
            <Route path="/link-card-dialog" component={LinkCardDialog} />
            <Route path="/fps-expired-dialog" component={FSPPayExpiredDialog} />
            <Route
              path="/fps-successful-dialog"
              component={FPSPaySuccessfulDialog}
            />
            <Route path="/history" component={History} />
            <Route path="/payment-card-management" component={ManageCards} />
            <Route path="/payment-amount-selection" component={Amount} />
            <Route path="/payment/attempt" component={PaymentAttempt} />
            <Route
              path="/payment/confirmation"
              component={PaymentConfirmation}
            />
            <Route path="/payment/success" component={PaymentSuccess} />
            <Route path="/payment/check" component={PaymentCheck} />
            <Route path="/payment/failed" component={PaymentFailed} />
            <Route path="/deferment/attempt" component={DefermentAttempt} />
            <Route path="/deferment/failed" component={DefermentFailed} />
            <Route path="/deferment/success" component={DefermentSuccess} />
            <Route path="/deferment" component={DefermentInfo} />
            <Route path="/sales" component={Sales} />
            <Route path="/subscriptions" component={SubscriptionsPage} />
            <Route path="/" component={Home} />
          </Switch>
        </Suspense>
      </Container>
    </BaseRouter>
  )
}

const Container = styled.div<{ background: string }>`
  background: ${({ background }) => background};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  will-change: background-image;
  padding: 38px 80px;
  height: 100vh;
`
